import { render, staticRenderFns } from "./MAFDialog.vue?vue&type=template&id=24cfa2e4&scoped=true&"
import script from "./MAFDialog.vue?vue&type=script&lang=js&"
export * from "./MAFDialog.vue?vue&type=script&lang=js&"
import style0 from "./MAFDialog.vue?vue&type=style&index=0&id=24cfa2e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cfa2e4",
  null
  
)

export default component.exports